export default {"src":"/_next/static/media/app-autopass.22d75670.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};